import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AptemComponent } from '../common/directives/aptem-component/aptem-component';
import { LoadingSpinnerConfig } from './loading-spinner.models';

@Component({
    selector: 'app-loading-spinner',
    imports: [NgClass],
    templateUrl: './loading-spinner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent extends AptemComponent<LoadingSpinnerConfig> {
  protected defaultConfig: Required<LoadingSpinnerConfig> = {
    color: 'primary',
    size: 'md',
  };
}
